import type { ForwardedRef } from "react";
import React from "react";

export const HiddenFormButton = React.forwardRef((_: object, ref: ForwardedRef<HTMLButtonElement>) => (
    <button
        ref={ref}
        type="submit"
        className="visually-hidden"
    >
        _
    </button>
));

HiddenFormButton.displayName = "HiddenFormButton";
